import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy, OnInit, OnDestroy } from '@angular/core';

import { Subject, of } from 'rxjs';
import { tap } from 'rxjs/operators';

import { EnvironmentCreate } from '../../interfaces';


@Component({
  selector: 'app-contact-info',
  templateUrl: './contact-info.component.html',
  styleUrls: ['./contact-info.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ContactInfoComponent implements OnInit, OnDestroy {

  @Input() public environmentCreate: EnvironmentCreate = null;

  @Output() public environmentCreateChange = new EventEmitter<EnvironmentCreate>();

  private _destroy$ = new Subject();

  constructor() { }

  public ngOnInit(): void {
  }

  public save = () => {
    return of(this.environmentCreate)
      .pipe(
        tap((response) => this.environmentCreateChange.emit(response)),
      );
  };

  public ngOnDestroy(): void {
    this._destroy$.next();
    this._destroy$.complete();
  }

}
